
import Vue from 'vue'
import gallery from '~/mixins.js/gallery'
import analytics from '~/mixins.js/analytics'
import diagram from '~/mixins.js/diagram'

export default {
  mixins: [gallery, analytics, diagram],
  props: {
    diagram: {
      required: true,
      type: Object
    },
    images: {
      required: true,
      type: Array
    },
    size: {
      required: true,
      type: String
    },
    totalCount: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      index: 0,
      navigateTo: 0,
      currentIndex: 0,
      imagesCount: 0,
      lazyImages: [],
      page: 1,
      pageSize: 5,
      ordering: 'order'
    }
  },
  computed: {
    allImages () {
      return [this.diagram.image, ...this.images, ...this.lazyImages]
    }
  },
  created () {
    if (process.client && window) {
      require('lightgallery.js/dist/css/lightgallery.min.css')
      const lightgallery = require('lightgallery.js')
      Vue.use(lightgallery)
    }
  },
  async mounted () {
    this.imagesCount = this.allImages.length
    try {
      const slideNumber = parseInt(/#slide_(\d+)/.exec(this.$route.hash)[1])

      if (slideNumber && this.totalCount > this.lazyImages.length + this.images.length) {
        await this.fetchLazySlides()
      }
      let slideIndex = this.allImages.findIndex(image => image.number === slideNumber)
      slideIndex = slideIndex === -1 ? 0 : slideIndex
      if (process.browser) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
      setTimeout(() => {
        this.navigateTo = slideIndex
        this.trackEvent('Gallery', 'Scroll to slide')
      }, 500)
    } catch {
      this.navigateTo = 0
    }
    this.$store.commit('diagram/setActiveSlideIndex', this.navigateTo)
  },
  methods: {
    imageSize (image) {
      return this.size === 'desktop' ? image.medium : image.small
    },
    async fetchLazySlides () {
      const lazy = await this.fetchSlides(2, this.pageSize)
      lazy.forEach((image, index) => {
        this.$set(
          this.lazyImages,
          index,
          image
        )
      })
    },
    async navigationHandler (direction) {
      if (this.totalCount > this.images.length + this.lazyImages.length) {
        await this.fetchLazySlides()
        this.currentIndex = 0
      }

      if (direction === 'forward') {
        if (this.currentIndex < this.allImages.length) {
          this.currentIndex++
        } else {
          this.currentIndex = 0
        }
      } else if (this.currentIndex === 0) {
        this.currentIndex = this.allImages.length
        this.navigateTo = this.allImages.length
      } else {
        this.currentIndex--
      }
      this.$store.commit('diagram/setActiveSlideIndex', this.currentIndex)
    }
  }
}
